import { useEffect, useState } from "react";

import FormModal from "../../widgets/FormModal";
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";


function ResearchInside() {

          const [show, setShow] = useState(false);
          const openIframeWindow = () => {
            setShow(!show);
          }
    return (
        <> <section className="light_bg">
            <Header />
            <div className="top_space"></div>
           
            <section className="ps">
                <div className="container">
                   <h1 className="hadding">Genetic Link Between Magnesium Deficiency, Depression, and Stress Resilience</h1>
                    <div className="position-relative  mt-4 mb-4">
                        <img src="/assets/img/research/genetic-link.webp" alt="research" className="w100 br20"/>
                    </div>
                    <h3 className="op0_8">Understanding the Study</h3>
                    <p>Depression and stress are not just emotional challenges; they’re deeply connected to how your body and brain function. A groundbreaking study conducted by Dr. Sajeev Nair, Reshma K.R., and team analyzed 500 genetic reports through EPLIMO, uncovering a remarkable connection between magnesium-related genes and mental health
                    </p>
                    The findings reveal that:
                    <ul class="mb-4 dot_list">
                        <li>99.6% of individuals studied had genetic markers linked to depression risk</li>
                        <li>98% showed genes associated with magnesium deficiency</li>
                    </ul>
                    <p>
                    This means magnesium plays a much bigger role in emotional well-being than most people realize.
                    </p>
                   
   <h3 className="op0_8">Why Magnesium Matters for the Mind</h3>
   <p>Magnesium is not just a mineral; it’s a vital brain nutrient. It helps regulate:</p>
          <ul class="mb-4 dot_list">
                        <li>Neurotransmitters like serotonin and dopamine (mood and motivation) </li>
                        <li>Neuronal signaling (brain communication) </li>
                        <li>The HPA axis, your body’s stress response system </li> 
                    </ul>
                     When magnesium levels drop, it can lead to: 
                    <ul class="mb-4 dot_list">
                        <li> Increased anxiety and irritability</li> 
                        <li>Fatigue and brain fog</li>
                       <li>Poor sleep and low resilience to stress </li>
                    </ul>
                <p> Simply put, magnesium deficiency can biochemically mimic depression.</p>


                 <h3 className="op0_8">Inside the Genetic Study</h3>
  Study Design: 
   



          <ul class="mb-4 dot_list">
                        <li> Sample Size: 500 individuals analyzed using EPLIMO genetic reports </li> 
                        <li> 
Focus: Genetic variants affecting stress resilience, depression risk, and magnesium metabolism </li>  
                    </ul>
                     Key Results: 
                    <ul class="mb-4 dot_list">
                        <li> 498 participants (99.6%) had genes predisposing them to depression </li> 
                        <li> 490 participants (98%) had genes linked to magnesium deficiency </li> 
                        <li> There was a strong overlap, those genetically prone to depression almost always had magnesium-related deficiencies </li> 
                    </ul>

                      <h3 className="op0_8">What This Means</h3>
                <p>This study provides the first clear genetic evidence that magnesium deficiency may directly contribute to depression and reduced stress resilience.</p>

                   <h3 className="op0_8">Interpretation:</h3>
                 <ul class="mb-4 dot_list">
                        <li>Magnesium acts as a key modifiable factor—something that can be corrected through diet, supplements, and lifestyle changes. </li> 
                        <li>People with magnesium-related genetic variants might not respond well to general diet or stress advice; they need personalized solutions. </li>  
                    </ul>


                          <h3 className="op0_8">Personalized Health Through EPLIMO</h3>
                <p>EPLIMO (Epigenetic Lifestyle Modification) uses your DNA, metabolism, and lifestyle data to create customized plans for nutrition, exercise, stress management, and supplementation.
</p>

          <p className=" ">
By identifying magnesium-related genetic risks early, EPLIMO helps individuals:</p>
        <ul class="mb-4 dot_list">
                        <li> 
Strengthen mental resilience  </li> 
 <li> Prevent depression and fatigue  </li> 
 <li> Improve focus, mood, and sleep quality
  </li> 
    </ul>
  <p> 
This personalized approach goes far beyond generic wellness; it’s precision mental health backed by genetics.
 </p>  

   <h3 className="op0_8">The Takeaway</h3>
  <ul class="mb-4 dot_list">
        <li> 98% of people may have genetic markers affecting magnesium levels </li> 
        <li>  Magnesium is a powerful yet often overlooked nutrient for emotional stability</li> 
        <li> Genetic testing can help personalize prevention and treatment strategies for depression </li> 
    </ul>
      <p>

Programs like EPLIMO are leading the future of science-backed mental health optimization, proving that true wellness starts at the genetic level.
 </p>

    <h3 className="op0_8">References</h3>
Adapted from:
  <ul class="mb-4 dot_list">
        <li>  
“Genetic Study Establishes Direct Link Between Depression and Lower Concentrations of Magnesium”
By Dr. Sajeev Nair, Reshma K.R., et al.
<br/>
<br/>
 (Supported by research from the American Journal of Medical Genetics, Nature Human Behaviour, and the Journal of the American Board of Family Medicine.) </li> 
    </ul>
      <p>

Programs like EPLIMO are leading the future of science-backed mental health optimization, proving that true wellness starts at the genetic level.
 </p>
        
                  

                    <div className="pt-4 text-center">
                        <a href="study-reveals-genetic" className="back_btn bn_btn"><i className="bi bi-chevron-left"></i></a>
                        <a href="study-reveals" className="next_btn bn_btn"><i className="bi bi-chevron-right"></i></a>
                    </div>

                </div>

            </section>


            <section className="you_ready_sec text-white position-relative  overflow-hidden">
                <img src="/assets/img/research/research_r_bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
                <img src="/assets/img/research/research_r_bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

                <div className="container position-relative">
                    <div className="row position-relative">
                        <div className="col-md-5  ms-auto">
                            <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
                            <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check. It’s a blueprint for living stronger,
                                longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start
                                living at your peak.</p>
                            <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                        </div> 
                    </div>
                      <FormModal show={show} setShow={setShow} />
                </div>
            </section>
             
            <Footer /> </section>
        </>
    );
}

export default ResearchInside;
